imagescrollposition=0;

function changeimg(ele) {
	var mainimg = document.getElementById("mainimg");
	var thumbone = document.getElementById("thumb1");
	var thumbtwo = document.getElementById("thumb2");
	var thumbthree = document.getElementById("thumb3");
	
	mainimg.src=ele.href;
	$("#product .altimg li a").css("opacity","0.7");
	ele.style.opacity="1.0";
}
$("#descriptionlinks a").click(function() {
	$("#descriptionlinks a").css("color","#777").css("text-decoration","none");
	$(this).css("color","#000").css("text-decoration","underline");
	var rel = $(this).attr("rel");
	$("#productinformation").children("div").css("display","none");
	$("#"+rel).css("display","block");
});

$("#contactlink").click(function() {
	$("#email").css("display","block");
	$("#join").css("display","none");
	$("#contactlink").css("color","#000").css("text-decoration","underline");
	$("#joinlink").css("color","#777").css("text-decoration","none");
	return false;
});
$("#joinlink").click(function() {
	$("#email").css("display","none");
	$("#join").css("display","block");
	$("#contactlink").css("color","#777").css("text-decoration","none");
	$("#joinlink").css("color","#000").css("text-decoration","underline");
	return false;
});

function sizeselect(ident,ele,sizeident,avail,varianttitle) {
	var hiddenvalue=document.getElementById(ident+"hidden");
	var size=ele.innerHTML;
	hiddenvalue.value=sizeident;
	for(i=0; i<avail.length; i++) {
		if(avail[i]!=false)
		document.getElementById("sizeselector"+ident+avail[i]).style.background="#ddd";
	}
	ele.style.background="#aaa";
  
  $(".altimg a[rel^='"+varianttitle+"']").click();
//alert($(".altimg a[rel^='"+varianttitle+"']").position().top);
/*  $("#altimgs .altimg").animate({
	scrollTop: $(".altimg a[rel^='"+varianttitle+"']").offset().top;
	},200);*/
	$("#altimgs .altimg").animate({"top": ($(".altimg a[rel^='"+varianttitle+"']").position().top)*-1},"200");
	imagescrollposition=$(".altimg a[rel^='"+varianttitle+"']").parent().index();
	hidearrows();
}



function goLite(element,color)
{
   element.style.backgroundColor = color;
}


$(document).ready(function(){
    $("form").each(function() {
		$(this).validate();
	});
  });



$.fn.preload = function() {
    this.each(function(){
        $('<img/>')[0].src = this;
    });
};
function preload(arrayOfImages) {
    $(arrayOfImages).each(function(){
        $('<img/>')[0].src = this;
        // Alternatively you could use:
        // (new Image()).src = this;
    });
}

$("#newsbar a.exit").click(function() {
	$("#newsbar").slideUp("100");
	$.cookie("newsbar","hide");
});

if($.cookie("newsbar") != "hide") {
	$("#newsbar").css("display","block");
}


/* $("#products").mouseenter(function() {
	$("#products li a").css("opacity",0.9);
}).mouseleave(function() {
	$("#products li a").css("opacity",1);
}); */


$("#contact .department").click(function() {
	$("#contact .department").css("background","#ddd")
	$(this).css("background","#aaa");
	$("#contactdepartmenthidden").val($(this).html());
	return false;
});

/*$('#facebook .wall').fbWall({
	id:'ThruxLawrence',
	accessToken:'AAAC7gAoWDQ0BAPzdRuyZAIPCVjZA5ZCfxobWxgiZBLbBZBcZBtBBpkAAMpGL9LIlF7QXRr88ZBO60qcAIKDC8w5vNYCKFIYD7ZCKJ7Ykc9AJYwCpt3YZCIJ2X',
	showGuestEntries:false,
	showComments:false,
	max:5,
	timeConversion:24
});*/

$("#products li a").mouseenter(function() {
	$(this).find("img").css("opacity","0.9");
}).mouseleave(function() {
	$(this).find("img").css("opacity","1");
});

/*$("#altimgs").mouseenter(function() {
	$("#altimgs .arrows").css("display","block");
}).mouseleave(function() {
	$("#altimgs .arrows").css("display","none");
});
*/


function hidearrows() {
	// Hide up/down arrows
	var countli=$(".altimg > li").length;
	countli -= 3;
	if(imagescrollposition==0) {
		$("#altimgs .up").css("visibility","hidden");
	} else if(imagescrollposition==countli) {
		$("#altimgs .down").css("visibility","hidden");
	} else {
		$("#altimgs .up").css("visibility","visible");
		$("#altimgs .down").css("visibility","visible");
	}
}

$("#altimgs .arrows").mouseover(function() {
	$(this).css("opacity","1");
}).mouseout(function() {
	$(this).css("opacity","0.7");
});
$("#altimgs .down").click(function() {
	$("#altimgs .altimg").animate({"top": "-=185px"},"200");
	imagescrollposition++;
	hidearrows();
	return false;
});
$("#altimgs .up").click(function() {
	if(imagescrollposition > 0) {
		$("#altimgs .altimg").animate({"top": "+=185px"},"200");
		imagescrollposition--;
		hidearrows();
	}
	return false;
});

$("#imgcontainer").mouseenter(function() {
	$("#imgcontainer .expand").css("display","block").css("opacity","0.5").attr("href",$("#mainimg").attr("src"));
}).mouseleave(function() {
	//
}).click(function() {
	$("#fancyboxlist a").eq(0).trigger('click');
	return false;
});

/*$("#imgcontainer .expand").mouseenter(function() {
	$(this).css("opacity","1.0");
}).mouseleave(function() {
	$(this).css("opacity","0.5");
});*/

$("#fancyboxlist a").fancybox({
	mouseWheel: false
});
$("#imgcontainer .expand").click(function() {
	$("#fancyboxlist a").eq(0).trigger('click');
	return false;
});


$(document).ready(function()
{
  $("#productfitguidelink").fancybox();
    $('#usamap a').each(function() {
		$(this).qtip({
        	content: $(this).html(),
        	style: {
            	classes: 'qtip-tipsy qtip-shadow'
        	}
    	});
	});
});


// Front page rollover
$(document).ready(function() {
    $("#products li a").mouseenter(function() {
        // enter
        $(this).find("div .mainimg").css("display","none");
        $(this).find("div .hover").css("display","block");
    }).mouseleave(function() {
        // leave
        $(this).find("div .mainimg").css("display","block");
        $(this).find("div .hover").css("display","none");
    });
});


